import React from "react";

interface IProps {
  children: any;
  ColumnsSize: number;
  ColumnsSizesMd?: number[];
  ClassNameParent?: string;
  ClassNameChild?: string;
}

const CpntFormSectionContainer: React.FC<IProps> = ({
  children,
  ColumnsSize,
  ColumnsSizesMd,
  ClassNameParent,
  ClassNameChild,
}) => {
  return (
    <div
        className={`form-section row ${
          ClassNameParent ? ClassNameParent : ""
        } `}
      >
        {React.Children.map(children, (child, i) => {
          if (child) {
            return (
              <div
                key={i + child?.props?.name}
                className={`mb-2 col-${ColumnsSize} ${
                  !ColumnsSizesMd
                    ? ""
                    : ColumnsSizesMd[i]
                    ? "col-md-" + ColumnsSizesMd[i]
                    : ""
                } ${ClassNameChild ? ClassNameChild : ""}
                `}
              >
                {child}
              </div>
            );
          }
        })}
      </div>
  );
};

export default CpntFormSectionContainer;
